var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.data
      ? _c(
          "div",
          [
            _c("Top"),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("Pagination", {
                      attrs: { numberOfDots: 5, numberOfVisitedDots: 1 }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "header-wrapper" }, [
                      _c("h2", {
                        staticClass: "text-primary-fh",
                        domProps: {
                          innerHTML: _vm._s(_vm.data.screening.medicineHeader)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.screening.medicineText)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _vm._l(_vm.data.misc.medicinelist, function(key, name, i) {
                      return _c("div", { key: name, staticClass: "card" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "text-light",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": "#card-" + key
                            }
                          },
                          [_vm._v(_vm._s(name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "collapse",
                            class:
                              _vm.druglist[i].dose ||
                              _vm.druglist[i].amountperday ||
                                _vm.druglist[i].injectionsperweek
                                ? "show"
                                : "",
                            attrs: { id: "card-" + key }
                          },
                          [
                            _c("div", { staticClass: "input-group" }, [
                              _vm.druglist[i].name !== "ezetrol" &&
                              _vm.druglist[i].name !== "praluent" &&
                              _vm.druglist[i].name !== "repatha"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.druglist[i].dose,
                                          expression: "druglist[i].dose"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-lg",
                                      attrs: { disabled: _vm.noMedicine },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.druglist[i],
                                            "dose",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { domProps: { value: 0 } }, [
                                        _vm._v("Välj dos")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.data.misc.doselist, function(
                                        dose
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: dose,
                                            domProps: { value: dose }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(dose) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.druglist[i].name === "ezetrol"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.druglist[i].dose,
                                          expression: "druglist[i].dose"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-lg",
                                      attrs: { disabled: _vm.noMedicine },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.druglist[i],
                                            "dose",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { domProps: { value: 0 } }, [
                                        _vm._v("Välj dos")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 10 } },
                                        [_vm._v("10")]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.druglist[i].name === "praluent"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.druglist[i].dose,
                                          expression: "druglist[i].dose"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-lg",
                                      attrs: { disabled: _vm.noMedicine },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.druglist[i],
                                            "dose",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { domProps: { value: 0 } }, [
                                        _vm._v("Välj dos")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 75 } },
                                        [_vm._v("75")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 150 } },
                                        [_vm._v("150")]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.druglist[i].name === "repatha"
                                ? _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.druglist[i].dose,
                                          expression: "druglist[i].dose"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-lg",
                                      attrs: { disabled: _vm.noMedicine },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.druglist[i],
                                            "dose",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { domProps: { value: 0 } }, [
                                        _vm._v("Välj dos")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { domProps: { value: 140 } },
                                        [_vm._v("140")]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.druglist[i].unit,
                                      expression: "druglist[i].unit"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg measure-unit-form-control",
                                  attrs: { disabled: "" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.druglist[i],
                                        "unit",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: 0 } }, [
                                    _vm._v("Välj mått")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.data.misc.measurementlist,
                                    function(measure) {
                                      return _c(
                                        "option",
                                        {
                                          key: measure,
                                          domProps: { value: measure }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(measure) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _vm.druglist[i].name !== "praluent" &&
                            _vm.druglist[i].name !== "repatha" &&
                            _vm.druglist[i].name !== "ezetrol"
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.druglist[i].amountperday,
                                        expression: "druglist[i].amountperday"
                                      }
                                    ],
                                    staticClass: "form-control form-control-lg",
                                    attrs: { disabled: _vm.noMedicine },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.druglist[i],
                                          "amountperday",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("Antal tabletter per dag")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.data.misc.amountperdaylist,
                                      function(apd) {
                                        return _c(
                                          "option",
                                          {
                                            key: apd,
                                            domProps: { value: apd }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(apd) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.druglist[i].name === "ezetrol"
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.druglist[i].amountperday,
                                        expression: "druglist[i].amountperday"
                                      }
                                    ],
                                    staticClass: "form-control form-control-lg",
                                    attrs: { disabled: _vm.noMedicine },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.druglist[i],
                                          "amountperday",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("Antal tabletter per dag")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { domProps: { value: 1 } }, [
                                      _vm._v("1")
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.druglist[i].name === "praluent" ||
                            _vm.druglist[i].name === "repatha"
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.druglist[i].injectionsperweek,
                                        expression:
                                          "druglist[i].injectionsperweek"
                                      }
                                    ],
                                    staticClass: "form-control form-control-lg",
                                    attrs: { disabled: _vm.noMedicine },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.druglist[i],
                                          "injectionsperweek",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("Antal injektioner varannan vecka")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { domProps: { value: 1 } }, [
                                      _vm._v("1")
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-group-toggle" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "btn btn-outline-secondary btn-lg btn-block checkbox-btn",
                          class: _vm.noMedicine
                            ? "active previous-answer"
                            : false
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.noMedicine,
                                expression: "noMedicine"
                              }
                            ],
                            attrs: { type: "checkbox", autocomplete: "off" },
                            domProps: {
                              value: true,
                              checked: Array.isArray(_vm.noMedicine)
                                ? _vm._i(_vm.noMedicine, true) > -1
                                : _vm.noMedicine
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.noMedicine,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = true,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.noMedicine = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.noMedicine = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.noMedicine = $$c
                                }
                              }
                            }
                          }),
                          _vm._v("\n            Nej\n            ")
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-lg btn-block",
                        attrs: {
                          disabled: !_vm.druglistIncomplete() && !_vm.noMedicine
                        },
                        on: {
                          click: function($event) {
                            return _vm.verifyMedicines()
                          }
                        }
                      },
                      [_vm._v("\n          Nästa")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-dark btn-lg btn-block",
                        on: {
                          click: function($event) {
                            return _vm.$router.go(-1)
                          }
                        }
                      },
                      [_vm._v("← Tillbaka")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("small", { staticClass: "pull-left" }, [
                      _vm._v(
                        "Tryck nästa för att gå vidare, annars kan du gå tillbaka."
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm" })
              ])
            ]),
            _vm._v(" "),
            _c("Bottom")
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fbbbc50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fbbbc50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScreeningMedicine.vue
// module id = null
// module chunks = 